import React, {useEffect, useState} from 'react';
import {activeFormPanel, add2ActiveFormPanel, changeFormsJsKey, mrbgStore} from './mrbgRedux/index.js';
import MrbgWs from './MrbgWs.jsx';
import mrbgS2S from '../../mrbgLib/mrbgS2S.js';
import {mrbgTools} from '../../mrbgLib/mrbgTools.js';

function MrbgAside({hideMenu,formsJsKey,readySettings,asideStyle}){

  const
    [view,setView] = useState(''),
    [activeForms,setActiveForms] = useState( mrbgStore.getState().activeForms ),
    aside      = {...mrbgStore.getState().mrbgVars.aside},
    mainSelect = mrbgStore.getState().mrbgVars.mainSelect,
    panelName  = mrbgStore.getState().mrbgVars.panelName;

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setActiveForms( mrbgStore.getState().activeForms )
    });
    return () =>unsubscribe();
  },[])

  return(
    <aside id={asideStyle.sideMenu} className={hideMenu? asideStyle.hideMenu:''}>
      <div id={asideStyle.verticalCursor}></div>
      <a href={mrbgStore.getState().url} id={asideStyle.companyName} target="_blank">{panelName}</a>
      <div id={asideStyle.userInfo}>
        <figure id={asideStyle.userFigure}>
          <img id={asideStyle.userPic} src={`/img/${mrbgStore.getState().__TK?.EP?.img||'_sup.webp'}`}/>
        </figure>
        <i onClick={()=>mrbgStore.dispatch(activeFormPanel('empAvtFrame'))} className="fa-solid fa-circle-plus"></i>
        <div className={`${asideStyle.organizationalGradiant} ${mrbgStore.getState().mrbgVars.wsConnection? asideStyle.online: asideStyle.offline}`}>
          {mrbgStore.getState().__TK?.EP?.userName}
          <MrbgWs {...{asideStyle}}/>
        </div>
      </div>
      { mainSelect && <MainSelectAside {...{mainSelect,asideStyle}} /> }
      <select name={formsJsKey} id={asideStyle.formsJsKey} data-id="formsJsKey" defaultValue={formsJsKey} onChange={e=>{mrbgStore.dispatch(changeFormsJsKey(e.target.value))}}>
        <option value="EP">حسابداری</option>
        <option value="AP">مدیریت سایت</option>
      </select>
      <ul id={asideStyle.mainListSide}>
        {
          Object.keys(aside).map((asideKey,k)=>{
            return(
              <React.Fragment key={k}>
                {
                  aside[asideKey].items instanceof Object?
                    <DropDownItems   {...{...aside[asideKey],activeForms,view,setView,readySettings,asideStyle}} k={k}/>:
                    <SimpleAsideItem {...{...aside[asideKey],readySettings,asideStyle}} k={k}/>
                }
              </React.Fragment>
            )
          })
        }
      </ul>
    </aside>
  );
}
function MainSelectAside({mainSelect,asideStyle}){

  const
    curVal = useState( mainSelect.curVal ),
    options = mrbgStore.getState().mrbgVars[mainSelect.options];

  function changeMain( val ){
    mrbgTools.cookie.set('lang',val,30);
    mrbgS2S(null, null,'chnMSA','load');
  }

  return(
    <select name={mainSelect.name} id={asideStyle.mainSelectAside} data-id="mainSelectAside" defaultValue={curVal} onChange={e=>changeMain(e.target.value)}>
      {
        Object.keys(options).map((key,i)=>{
          return <option value={key} key={i}>{options[key]}</option>
        })
      }
    </select>
  )
}
function DropDownItems({title,icon,items,activeForms,k,view,setView,readySettings,asideStyle}){

  var
    cnt = 0,
    intersect = Object.keys(items).filter(x => activeForms.includes(x)),
    formIDs = [];

  Object.keys(items).map(fID=>{
    var id = fID.replace('Frame','');
    if( Object.hasOwn(readySettings,id) )
      formIDs.push(id);
  })

  if( formIDs.length )
    return(
      <li className={asideStyle.MDD_continer} onClick={()=>setView(k)}>
        <div>
          {
            /[\p{Emoji}]/u.test(icon)?
              <i>{icon}</i>:
              <i className={icon}></i>
          }
          <span className={asideStyle.elypsisItem}>
            {title}
          </span>
          <i  className={`fa-regular fa-chevron-circle-down ${(view!==k && intersect.length==0 )? '':asideStyle.up}`}></i>
        </div>
        <ul className={`${asideStyle.menuDropDown} ${(view!==k &&  intersect.length==0)? asideStyle.menuDropUp:''}`} style={{height:Object.keys(items).length*40+'px'}}>
          {
            Object.keys(items).map((dataFormID)=>{
              return(
                <li className={activeForms.includes(dataFormID)? asideStyle.currentLink:''} onClick={e=>{e.ctrlKey? mrbgStore.dispatch(add2ActiveFormPanel(dataFormID)): mrbgStore.dispatch(activeFormPanel(dataFormID))}} key={cnt++}>
                  <span className={`${asideStyle.elypsisItem}`}>{items[dataFormID]}</span>
                </li>
              )
            })
          }
        </ul>
      </li>
  )
}
function SimpleAsideItem({title,icon,items,asideStyle}){

  return(
    <li onClick={e=>{items=='logOut'? mrbgTools.logOut(): e.ctrlKey? mrbgStore.dispatch(add2ActiveFormPanel(items)): mrbgStore.dispatch(activeFormPanel(items))}} >
      <span>
        <i className={icon}></i>
        <span className={asideStyle.elypsisItem}>{title}</span>
      </span>
    </li>
  )
}

export default MrbgAside;